/**
 * Helper function that allows filtering of keys in an object by a given set and with an optional processer, key values can be transformed.
 */

export interface Dictionary {
  [index: string]: any | null;
}

export type Transformer = (arg0: string | null) => string | null;

function filter<T extends Dictionary>(attrs: T, keys: string[], transformer?: Transformer) {
  return keys.reduce<Dictionary>((obj, key) => {
    obj[key] = transformer ? transformer(attrs[key]) : attrs[key];

    return obj;
  }, {});
}

export default filter;
